/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { PostApiBarberShiftBook200, PostApiBarberShiftBook400, PostApiBarberShiftBook401, PostApiBarberShiftBook403, PostApiBarberShiftBook404, PostApiBarberShiftBook500, PostApiBarberShiftBookMutationRequest, PostApiBarberShiftBookMutationResponse } from "../entities/PostApiBarberShiftBook";
import { modelsErrorResponseSchema } from "./models/errorResponseSchema";
import { modelsShiftBookInputSchema } from "./models/shiftBookInputSchema";
import { modelsShiftSchema } from "./models/shiftSchema";
import { z } from "zod/v4";

/**
 * @description OK
 */
export const postApiBarberShiftBook200Schema = z.lazy(() => modelsShiftSchema) as unknown as z.ZodType<PostApiBarberShiftBook200>

/**
 * @description Bad Request
 */
export const postApiBarberShiftBook400Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberShiftBook400>

/**
 * @description Unauthorized
 */
export const postApiBarberShiftBook401Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberShiftBook401>

/**
 * @description Forbidden
 */
export const postApiBarberShiftBook403Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberShiftBook403>

/**
 * @description Not Found
 */
export const postApiBarberShiftBook404Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberShiftBook404>

/**
 * @description Internal Server Error
 */
export const postApiBarberShiftBook500Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberShiftBook500>

/**
 * @description Данные смены
 */
export const postApiBarberShiftBookMutationRequestSchema = z.lazy(() => modelsShiftBookInputSchema) as unknown as z.ZodType<PostApiBarberShiftBookMutationRequest>

export const postApiBarberShiftBookMutationResponseSchema = z.lazy(() => postApiBarberShiftBook200Schema) as unknown as z.ZodType<PostApiBarberShiftBookMutationResponse>